<template>
    <register-admin ref="registerAdmin" v-bind:is-me="false" v-bind:title="'Δημιουργία Διαχειριστή Διεύθυνσης Επιστρατεύσεως'" />
</template>

<script>
import RegisterAdmin from "./RegisterAdmin";

export default {
    name: "RegisterDes",
    created() {
         if(!this.$store.getters.isAdmin) this.$router.push('/');
    },
    components: {
        RegisterAdmin
    }
}
</script>

<style scoped>

</style>